// extracted by mini-css-extract-plugin
export var cardWrapper = "_6r-0";